export default "Lav jeres egne simple rytmepinde af grene og lav fede stenalder-rytmer!";